<div class="help-page__help-icon">
  <eop-icon identifier="speechbubble-questionmark" color="inherit" aria-hidden="true"></eop-icon>
</div>

<div class="help-page__content" role="main">
  <h1 class="help-page__header">{{ 'global.help-footer.header' | translate }}</h1>

  <button branded (click)="openHelpView()" class="button-filled-primary mtop">
    {{ 'help-page.help' | translate }}
  </button>
  <button branded (click)="openContactView()" class="button-filled-primary">
    {{ 'help-page.contact-text' | translate }}
  </button>
  <div class="help-page__header help-page__header--sub-header">
    {{ 'help-page.subline-legal' | translate }}
  </div>
  <button branded (click)="openImprintView()" class="button-filled-primary mtop">
    {{ 'help-page.imprint' | translate }}
  </button>
  <button branded (click)="openPrivacyView()" class="button-filled-primary">
    {{ 'help-page.privacy' | translate }}
  </button>
  <button branded (click)="openTermsView()" class="button-filled-primary">
    {{ 'help-page.terms' | translate }}
  </button>

  <button class="cdk-visually-hidden" aria-hidden="false"
          (click)="exit.emit()"
  >{{ 'help-page.a11y.help-menu-close' | translate }}</button>
</div>

<div class="help-page__footer" role="footer">
  <div class="copyright">&#169; 2026 vaylens GmbH</div>
</div>
